export default __webpack_public_path__ + "static/media/unavailable-white.92e35215.svg";